export default __webpack_public_path__ + "static/media/selectcard.836862f9.mp3";